<template>
  <div class="container">
    <div class="form-wrap">
      <el-form :model="loginForm" :rules="rules" status-icon ref="loginForm" label-width="80px" class="demo-ruleForm">
        <el-form-item label="用户名：" prop="account">
          <el-input type="text" v-model="loginForm.account" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码：" prop="password">
          <el-input type="password" v-model="loginForm.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="" style="margin-top:-15px;" >
          <el-checkbox label="记住密码" name="type" v-model="saveWordFlag"></el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm" style="margin-right:30px;">登录</el-button>
          <el-button @click="$refs.ruleForm.resetFields()">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
// import axios from 'axios'
import { loginApi } from '@/utils/api.js'
export default {
  data () {
    return {
      loginForm: {
        account: undefined,
        password: undefined
      },
      saveWordFlag: true,
      rules: {
        account: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    let userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      this.loginForm = JSON.parse(userInfo)
    }
  },
  mounted () {
    let that = this
    document.onkeydown = function (e) {
      e = window.event || e
      if (e.code === 'Enter' || e.code === 'enter') {
        that.submitForm()
      }
    }
  },
  methods: {
    async submitForm () {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          if (this.saveWordFlag) {
            localStorage.setItem('userInfo', JSON.stringify(this.loginForm))
          } else {
            localStorage.removeItem('userInfo')
          }
          const data = await loginApi({
            ...this.loginForm
          })
          localStorage.setItem('accessToken', data.token)
          this.$router.push('../list')
        }
      })
    }
  }
}
</script>
<style scoped>
.container {
  width: 100%;
  height: calc(100vh - 50px);
  background: url(../../assets/banner1.png) 0 0;
  background-size: 100% 100%;
  position: relative;
}
.el-form-item__content .el-checkbox__label {
  color:#ed1846;
}
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: #ed1846;
  border: 1px solid #ed1846;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #ed1846;
}
.el-button--primary {
  background: #ed1846;
  border: 1px solid #ed1846;
}
.el-button--primary.is-plain {
  background: #fae7ec;
  border: 1px solid #f35678;
  color: #ed1846;
}
.form-wrap {
  width: 400px;
  height: 320px;
  background: #fff;
  border-radius: 20px;
  position: fixed;
  right: 100px;
  top: 50%;
  margin-top: -160px;
}
.demo-ruleForm {
  width: 350px;
  margin: 70px auto 0;

}
</style>



// WEBPACK FOOTER //
// src/views/register/index.vue